import * as types from '@/store/mutation-types'
import { MULTI_CHANNEL_WIDGETS, MULTICHANNEL_DEFAULT_SETTINGS, WIDGET_MOBILE_BREAKPOINT } from '@/constants'

export default {
  [types.SET_IS_LOADING] (state, status) {
    state.isLoading = status
  },
  [types.SET_IS_WIDGET_OPEN] (state, status) {
    state.isWidgetOpen = status
  },
  [types.SET_PARENT_SIZE_INFO] (state, parentSizeInfo) {
    state.isMobile = parentSizeInfo.clientWidth < WIDGET_MOBILE_BREAKPOINT
    state.parentHeight = parentSizeInfo.clientHeight
    state.parentWidth = parentSizeInfo.clientWidth
  },
  [types.SET_WIDGET_SETTINGS] (state, widgetSettings) {
    widgetSettings.map(ws => {
      // Add the default values to the state if the data is null.
      if (ws.setting_name === 'headingText' && !ws.setting_value) {
        ws.setting_value = MULTICHANNEL_DEFAULT_SETTINGS.headingText
      }
      if (ws.setting_name === 'subHeadingText' && !ws.setting_value) {
        ws.setting_value = MULTICHANNEL_DEFAULT_SETTINGS.subHeadingText
      }

      state.settings[ws.setting_name] = ws.setting_value
    })
  },
  [types.SET_WIDGETS] (state, widgetSettings) {
    const enabledChannels = widgetSettings.filter(ws => ws.setting_name === 'enabledChannels').map(ws => ws.setting_value)[0]
    const enabledWidgets = MULTI_CHANNEL_WIDGETS.filter((widget) => {
      return (enabledChannels.includes(widget.id))
    })

    state.widgets = enabledWidgets
  },
  [types.SET_PRACTICE_LOCATIONS] (state, locations) {
    state.practiceLocations = locations
  },
  [types.SET_IS_MOBILE_SAFARI] (state, isMobileSafari) {
    state.isMobileSafari = isMobileSafari
  }
}
